var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('iframe',{staticClass:"review_css",staticStyle:{"border":"1px","box-shadow":"none"},attrs:{"id":"my_iframe","src":_vm.url,"scrolling":"yes","width":_vm.width,"height":_vm.height}})])}
var staticRenderFns = []

export { render, staticRenderFns }